import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=cc8f0e30&"
import script from "./Workflows.vue?vue&type=script&lang=ts&"
export * from "./Workflows.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports